import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() { }

    disconnect() {
        document.removeEventListener("turbo:before-stream-render", this.handleTurboStream.bind(this))
    }

    handleTurboStream(event) {
        const targetElement = event.detail.newStream.getAttribute("target")

        if (targetElement === "workspace-created") {
            const action = event.detail.newStream.getAttribute("action")

            if (action === "replace") {
                const content = event.detail.newStream.innerHTML
                const match = content.match(/data-workspace-id="(\d+)"/)

                if (match) {
                    const workspaceId = match[1]

                    setTimeout(() => {
                        this.selectWorkspace(workspaceId)
                    }, 500)
                }
            }
        }
    }

    selectWorkspace(workspaceId) {
        setTimeout(() => {
            const button = this.element.querySelector('button[x-on\\:click="toggle()"]')
            if (button) {
                button.click() // Ouvrir le dropdown

                // Attendre que le dropdown soit ouvert, puis cliquer sur la bonne option
                setTimeout(() => {
                    const optionButtons = this.element.querySelectorAll('button[type="button"]')

                    for (let optionButton of optionButtons) {
                        const clickAttr = optionButton.getAttribute('x-on:click')
                        if (clickAttr && clickAttr.includes(`selectOption('${workspaceId}')`)) {
                            optionButton.click()
                            return
                        }
                    }
                }, 100)
            }
        }, 200)
    }
}